(function() {
	'use strict';
	angular.module('app.setup')
		.service('valueStreamService', valueStreamService);

	valueStreamService.$inject = ['$http', 'URLS'];
	function valueStreamService($http, URLS) {
		return {
			addValueStream: addValueStream,
			updateValueStream: updateValueStream,
			deleteValueStream: deleteValueStream,
			getUsers: getUsers,
			getValueStreamDependencyCount: getValueStreamDependencyCount
		};

		function addValueStream(valueStream, siteId) {
			var pageUrl = String.format(URLS.factoryValueStream, siteId || globalConfig.factory.id);
			return $http.post(URLS.host + pageUrl, valueStream)
				.then(addValueStreamSuccess, handleError);

			function addValueStreamSuccess(response) {
				return 'Value stream created successfully';
			}
		}

		function updateValueStream(valueStream, lastModified, siteId) {
			var pageUrl = String.format(URLS.factoryValueStream, siteId || globalConfig.factory.id);
			return $http.put(URLS.host + pageUrl + '/' + valueStream.ndx, valueStream, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateValueStreamSuccess, returnError);

			function updateValueStreamSuccess(response) {
				return response;
			}
		}

		function deleteValueStream(valueStreamNdx, siteId) {
			var pageUrl = String.format(URLS.factoryValueStream, siteId || globalConfig.factory.id);
			return $http.delete(URLS.host + pageUrl + '/' + valueStreamNdx)
				.then(deleteValueStreamSuccess, handleError);

			function deleteValueStreamSuccess(response) {
				return 'Value stream deleted successfully';
			}
		}

		function getUsers(inactiveUserNdx, siteId) {
			var pageUrl = String.format('2/Dimensions/factndx/{0}/FactoryUsers', siteId || globalConfig.factory.id);
			return $http.get(URLS.host + pageUrl + '?excludeSupplier=true&excludeReadOnly=true' + (inactiveUserNdx ? '&inactiveUserNdx=' + inactiveUserNdx : ''))
				.then(getUsersComplete, handleError);

			function getUsersComplete(response) {
				return response.data.map(function(user) {
					return { 'name': user.firstName + ' ' + user.lastName + (user.state == 'inactive'? ' (inactive)' : ''), 'id': user.ndx };
				});
			}
		}

		function getValueStreamDependencyCount(valueStreamNdx, siteId) {
			var pageUrl = String.format(URLS.factoryValueStream, siteId || globalConfig.factory.id);
			return $http.get(URLS.host + pageUrl + '/Dependency/Count/' + valueStreamNdx)
				.then(getValueStreamDependencyCountSuccess, handleError);

			function getValueStreamDependencyCountSuccess(response) {
				return response.data;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412 || error.status === 409) {
				return error.data.error;
			} 
			return 'Unknown server error';
		}

		function returnError(error) {
			return error;
		}
	}
})();
